const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M188.7,373.75H35.5c-4.7,0-8.5-3.8-8.5-8.5V64.55c0-4.7,3.8-8.5,8.5-8.5h153.2V373.75L188.7,373.75z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.7,
    y: 56.15,
    style: {
      fill: "#F5F5F5"
    },
    width: 161.6,
    height: 317.7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M503.5,373.75H350.3V56.15h153.2c4.7,0,8.5,3.8,8.5,8.5v300.8 C511.9,370.05,508.1,373.75,503.5,373.75z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD250"
    },
    points: "283.9,222.45 269.5,229.65 269.5,236.85 276.7,236.85 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00C3A0"
    },
    d: "M269.5,254.85c-2,0-3.6-1.6-3.6-3.6v-14.4c0-2,1.6-3.6,3.6-3.6s3.6,1.6,3.6,3.6v14.4 C273.1,253.25,271.5,254.85,269.5,254.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00C3A0"
    },
    d: "M269.5,240.45c-14.2,0-27.9-5.5-38.5-15.4c-1.5-1.3-1.5-3.7-0.2-5.1c1.3-1.5,3.7-1.5,5.1-0.2 c9.3,8.7,21.2,13.5,33.6,13.5s24.3-4.7,33.6-13.5c1.5-1.3,3.7-1.3,5.1,0.2c1.3,1.5,1.3,3.7-0.2,5.1 C297.3,234.95,283.7,240.45,269.5,240.45z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AADC"
    },
    d: "M269.5,254.85c-9.2,0-18.2-2.7-25.9-7.8l4-6c13,8.7,30.8,8.7,43.8,0l4,6 C287.7,252.15,278.7,254.85,269.5,254.85z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#732D37"
    },
    points: "263.8,206.25 255.8,218.55 254.5,222.55 275.2,217.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AAD264"
    },
    d: "M247.5,226.55c-9.5,0-21-8-24-25.9l7.1-1.2c2.5,14.9,11.7,19.9,17.1,19.9c1.7-0.1,3.5-0.6,3.6-1.8 c0.2-1.4,0.2-1.7-3.6-3c-2.1-0.7-4.4-1.5-6-3.3c-6.6-7.5,2.3-15.5,6.6-19.3c0.8-0.7,1.1-1.2,1-1.5c-0.3-0.6-1.7-1.5-3.3-1.5 c-4.6,0-8-2.6-9-6.7c-1-4.3,1-8.9,4.7-10.8l3.3,6.4c-0.9,0.4-1.2,1.7-1,2.7c0.1,0.4,0.3,1.2,2.1,1.2c4.4,0,8.6,2.6,10,6.2 c0.6,1.5,1.5,5.5-3,9.4c-4.7,4.2-7.6,7.4-6,9.2c0.4,0.4,1.9,0.9,2.9,1.3c3.3,1.1,9.3,3.1,8.4,10.7c-0.5,4.7-4.7,8-10.5,8.2 C247.7,226.55,247.6,226.55,247.5,226.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#874150"
    },
    d: "M276.7,186.35c0,0,7.2-14.4-7.2-21.6c0,0,50.4-7.2,43.3,57.7l0,0c-4.7-3.8-11.7-10.7-14.2-16.2 l-21.8-12.6L276.7,186.35L276.7,186.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#732D37"
    },
    d: "M269.5,200.85l36.1,21.6c0,0,0,0-14.4,7.2l-21.6-21.6v-7.2H269.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#783C46"
    },
    d: "M255.1,179.25L255.1,179.25c4,0,7.2,3.2,7.2,7.2l0,0c-4.3,4.3-5.4,10.8-2.6,16.3l1.6,3.3 c0.7,1.3,1.6,2.6,2.6,3.7l20,20v-9.9c0-12.4-2.9-24.6-8.5-35.7l0,0c-3.7-7.3-11.2-11.9-19.3-11.9h-1L255.1,179.25L255.1,179.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD250"
    },
    d: "M255.1,171.95l-7.2,7.2v7.2c0,0,8.6-4.4,11.5-5.7c2-1,1.7-3.3,0.5-4.4 C258.9,175.45,255.1,171.95,255.1,171.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AAD264"
    },
    d: "M269.5,269.35c-33.8,0-61.3-27.5-61.3-61.3h7.3c0,29.8,24.3,54.1,54.1,54.1s54.1-24.3,54.1-54.1h7.2 C330.8,241.75,303.3,269.35,269.5,269.35z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M220.6,228.65c0.5,3.3-2.3,6.1-5.6,5.6c-2.1-0.3-3.7-2-4-4c-0.5-3.3,2.3-6.1,5.6-5.6 C218.6,224.85,220.3,226.55,220.6,228.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M231.5,245.85c0.5,3.3-2.3,6.1-5.6,5.6c-2.1-0.3-3.7-2-4-4c-0.5-3.3,2.3-6.1,5.6-5.6 C229.5,242.15,231.2,243.85,231.5,245.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M249.1,258.95c0.5,3.3-2.3,6.1-5.6,5.6c-2.1-0.3-3.7-2-4-4c-0.5-3.3,2.3-6.1,5.6-5.6 C247,255.25,248.7,256.95,249.1,258.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M318.9,228.65c-0.5,3.3,2.3,6.1,5.6,5.6c2.1-0.3,3.7-2,4-4c0.5-3.3-2.3-6.1-5.6-5.6 C320.9,224.85,319.1,226.55,318.9,228.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M308,245.85c-0.5,3.3,2.3,6.1,5.6,5.6c2.1-0.3,3.7-2,4-4c0.5-3.3-2.3-6.1-5.6-5.6 C310,242.15,308.4,243.85,308,245.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M290.5,258.95c-0.5,3.3,2.3,6.1,5.6,5.6c2.1-0.3,3.7-2,4-4c0.5-3.3-2.3-6.1-5.6-5.6 C292.4,255.25,290.8,256.95,290.5,258.95z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB478"
    },
    d: "M273.1,258.45h-7.2c-4,0-7.2-3.2-7.2-7.2l0,0c0-4,3.2-7.2,7.2-7.2h7.2c4,0,7.2,3.2,7.2,7.2l0,0 C280.3,255.25,277.1,258.45,273.1,258.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B4B5A"
    },
    d: "M298.5,206.25c2.4,7.1,7.5,13.5,14.2,16.2l0,0c7.2-64.9-43.3-57.7-43.3-57.7 C305.5,164.75,298.5,206.25,298.5,206.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E3033"
    },
    d: "M19.1,488.05L19.1,488.05c-10.6,0-19.1-8.6-19.1-19.1V42.85c0-10.5,8.5-18.9,18.9-18.9H19 c10.6,0,19.1,8.6,19.1,19.1v425.9C38.3,479.45,29.7,488.05,19.1,488.05z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMx);
export default __webpack_public_path__ + "static/media/mx.d7c4dfa8b097eef228d5719cdffb96fd.svg";
export { ForwardRef as ReactComponent };